import gql from 'graphql-tag';

export default gql`
    query CheckIsLoadAccessible($input: CheckIsLoadAccessibleInput) {
        checkIsLoadAccessible(input: $input) {
            isAccessible
        }
    }
`;
